(function () {
    'use strict';

    angular
        .module('bcmModule')
        .directive('biaKeyPerson', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                keyPerson: '=model'
            },
            restrict: 'A',
            templateUrl: require('./biaKeyPersonDirective.tpl.html')
        };
    }
})();
